import { theme, Typography } from 'antd'
import dayjs from 'dayjs'
import { Trans, useTranslation } from 'react-i18next'
import manWritingCheckmarkToChecklist from '../../resources/img/man-writing-checkmark-to-checklist.svg'

export function Completed({
  onboarding: {
    company: { name },
    firstMonth,
  },
}) {
  const { token } = theme.useToken()
  const { t } = useTranslation()

  return (
    <>
      <img
        src={manWritingCheckmarkToChecklist}
        alt=""
        style={{
          height: 450,
          position: 'absolute',
          left: -70,
          bottom: -70,
          zIndex: 1,
        }}
      />
      <div
        style={{
          maxWidth: '35em',
          marginLeft: 'auto',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <Typography.Title
          level={3}
          style={{ marginBottom: token.marginLG, marginTop: token.marginLG }}
        >
          {t('frontend:onboarding.completedTitle')}
        </Typography.Title>
        <Typography.Paragraph>
          <Trans
            i18nKey="frontend:onboarding.completedThanks"
            components={{ strong: <strong /> }}
            values={{
              name,
              firstMonth: dayjs(firstMonth).format('MMMM YYYY'),
            }}
          />
        </Typography.Paragraph>
        <Typography.Paragraph>
          {t('frontend:onboarding.completedFollowUp')}
        </Typography.Paragraph>
        <Typography.Paragraph>
          {t('frontend:onboarding.completedClose')}
        </Typography.Paragraph>
      </div>
    </>
  )
}
